<script lang="ts">
  import {
    getContextedUrl,
    globalCurrencyTag,
    isDirectionRTL,
    isMobile,
    getProductFinalPricingData,
  } from '../../../common/util';
  import Text from '../components/Text.svelte';
  import PictureTag from './PictureTag.svelte';

  export let cartEntries;
  export let totalProductsToDisplay;
  export let countClickUrl;
  const isRTL = isDirectionRTL();
  const isResponsive = isMobile();
  $: centeredSlides = isResponsive && cartEntries.length === 1;
  $: cartEntriesToDisplay = cartEntries?.slice(0, totalProductsToDisplay);
  $: totalRemainingProducts = cartEntries?.length - totalProductsToDisplay;

  function isProductOutOfStock(product) {
    const {
      stock: { stockLevelStatus },
    } = product;
    return stockLevelStatus === 'outOfStock';
  }
</script>

{#if cartEntriesToDisplay?.length > 0}
  <section class="cart-item-carousel-container">
    <swiper-container slides-per-view="auto" space-between="8" centered-slides={centeredSlides}>
      {#each cartEntriesToDisplay as entry}
        {@const finalPricing = getProductFinalPricingData(entry)}
        <swiper-slide>
          <a
            href={getContextedUrl(entry.product.url)}
            class="cart-product-tile scale-on-hover {entry?.product?.isJoodMegaSaleProduct ? 'megasale-product' : ''}"
          >
            {#if isProductOutOfStock(entry.product)}
              <div class="oos-tag">
                <Text key="product.Stock.stockLevelStatus.outOfStock" />
              </div>
            {/if}
            <section class="product-image">
              <PictureTag image={entry.product.amplienceProductBaseUrl} getAllResolutions={false} height="90px;128px" />
            </section>
            <section class="title">
              <strong
                >{entry.product.brandName}
                <span class="period">&period;</span></strong
              >
              {entry.product.name}
            </section>
            <section class="price-and-discount">
              <section class="price" class:rtl={isRTL}>
                {@html globalCurrencyTag}
                <strong>{finalPricing.price}</strong>
              </section>

              {#if finalPricing.discountPercentage > 0}
                <section class="discount-percent">
                  {finalPricing.discountPercentage}% <Text key="product.pourcentageDiscount.off" />
                </section>
              {/if}
            </section>
          </a>
        </swiper-slide>
      {/each}
      {#if totalRemainingProducts > 0}
        <swiper-slide class="remaining-count-slide">
          <a class="remaining-product-count" href={getContextedUrl(countClickUrl)}>
            +{totalRemainingProducts}
          </a>
        </swiper-slide>
      {/if}
    </swiper-container>
  </section>
{/if}

<style lang="scss">
  @import '../styles/colors.new.scss';

  swiper-container {
    width: 100%;
  }

  .cart-item-carousel-container {
    display: flex;
    gap: 16px;

    .cart-product-tile {
      padding: 12px 12px 16px;
      border: 1px solid $secondary-gray-02;
      border-radius: 8px;
      width: 164px;
      position: relative;
      display: inline-block;

      @include desktop-min-width {
        padding: 24px 16px 32px;
        width: 230px;
      }

      &.skeleton-item {
        height: 260px;
      }
      .product-image {
        width: fit-content;
        margin-inline: auto;
      }
      .title {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        max-height: 28px;
        overflow-y: hidden;
        color: $neutral-dark-01;

        .period {
          font-size: 16px;
          line-height: 0;
          transform: translateY(-3px);
          display: inline-block;
        }
      }

      .price-and-discount {
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .price {
          font-size: 14px;
          font-weight: 400;
          line-height: 16px;
          color: $neutral-dark-01;
          &.rtl {
            display: flex;
            flex-direction: row-reverse;
          }

          @include desktop-min-width {
            font-size: 16px;
            line-height: 18px;
          }
        }
      }
      .discount-percent,
      .oos-tag {
        font-size: 8px;
        font-weight: 700;
        line-height: 10px;
        padding: 1px 2px;
        color: $primary-white;
        background-color: $functional-orange;
        border-radius: 3px;

        @include desktop-min-width {
          font-size: 10px;
          line-height: 12px;
          padding: 2px 5px;
        }
      }
      .oos-tag {
        position: absolute;
        right: 12px;
        top: 12px;
        background-color: $neutral-light-03;
        color: $neutral-dark-04;
      }
      &.megasale-product {
        .discount-percent {
          color: $extraTagTextColor;
          background: $extraTagBg;
        }
      }
    }

    swiper-slide.remaining-count-slide {
      display: flex;
      align-items: center;
    }
    .remaining-product-count {
      display: inline-block;
      padding: 8px;
      border-radius: 50%;
      background-color: $neutral-light-03;
      color: $neutral-dark-04;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
    }
  }
</style>
